import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import PrintIcon from '@material-ui/icons/Print'
import CircularProgress from '@material-ui/core/CircularProgress'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'

const styles = theme => ({
  button: {
    margin: 10
  },
  buttonProgress: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12
  }
})
class TicketPrintForm extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    hiboutikAccount: PropTypes.string.isRequired,
    saleId: PropTypes.string.isRequired
  }
  static defaultProps = {
    disabled: false
  }
  state = {
    iframe: true,
    disabled: false
  }
  componentWillMount() {
    const { disabled } = this.props
    this.setState({ disabled: disabled })
  }
  handleSubmitClick = e => {
    this.setState({ iframe: true, disabled: true })
    this.refs.print_form.submit()
  }
  handleLoaded = e => {
    this.setState({ iframe: false, disabled: false })
  }
  render() {
    const { classes, saleId, hiboutikAccount, disabled, className } = this.props
    return (
      <div>
        <Button
          color="primary"
          className={className || classes.button}
          variant="raised"
          disabled={disabled}
          onClick={this.handleSubmitClick}>
          <PrintIcon color="inherit" />
          {disabled && (
            <CircularProgress
              color="primary"
              size={24}
              className={classes.buttonProgress}
            />
          )}
        </Button>
        <form
          ref="print_form"
          method="post"
          action={`https://${hiboutikAccount}.hiboutik.com/?print`}
          target="hbIframe">
          <input type="hidden" name="ma_commande_affiche" value={saleId} />
          <input type="hidden" name="ticket_pour" value="client" />
          <input type="hidden" name="action" value="impression_ticket" />
          <input type="hidden" name="xqk123pop_onar" value="0" />
        </form>
        {this.state.iframe && (
          <iframe
            title="print_iframe"
            onLoad={this.handleLoaded}
            ref="hbIframe"
            name="hbIframe"
            hidden
          />
        )}
      </div>
    )
  }
}
const mapStateToProps = state => {
  return {
    hiboutikAccount: state.auth.hiboutikAccount
  }
}

export default connect(mapStateToProps, {})(withStyles(styles)(TicketPrintForm))



// WEBPACK FOOTER //
// ./src/components/hiboutikForms/TicketPrintForm.js